define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/widgets/nls/zh-tw/variationItem"
,"scramble/widgets/nls/zh/variationItem"
,"scramble/widgets/nls/ja/variationItem"
,"scramble/widgets/nls/fr/variationItem"
,"scramble/widgets/nls/de/variationItem"
,"scramble/widgets/nls/ko/variationItem"
,"scramble/widgets/nls/it/variationItem"
,"scramble/widgets/nls/cs/variationItem"
,"scramble/widgets/nls/tr/variationItem"
,"scramble/widgets/nls/pl/variationItem"
,"scramble/widgets/nls/fi/variationItem"
,"scramble/widgets/nls/hu/variationItem"
,"scramble/widgets/nls/sk/variationItem"
,"scramble/widgets/nls/nb/variationItem"
,"scramble/widgets/nls/es/variationItem"
,"scramble/widgets/nls/nl/variationItem"
,"scramble/widgets/nls/pt/variationItem"
,"scramble/widgets/nls/ru/variationItem"
,"scramble/widgets/nls/sv/variationItem"
,"/home/semaphore/scramble4/src/scramble/widgets/nls/variationItem.js?absMid=scramble/widgets/nls/variationItem"
], function(loader, runner) {
   return runner(loader, "scramble/widgets/nls/variationItem", __webpack_require__.dj.c(), false);
});